import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from "@angular/common/http";
import {Room} from "../_models/room";
import {apiUrl} from "../../environments/environment";
import {map, Observable, of} from "rxjs";
import {Page} from "../_models/page";
import {Project} from "../_models/project";
import {GlobalTemplate, TemplateSourceSectionFilterOption} from "../_models/global-template";
import {SubRole} from "../_models/user";
import {convertSubRoleToEnum} from "../_util/utils";
import {SUPPRESS_DUPLICATE_NAME_NOTIFICATION} from "../_interceptors/error-interceptor.context";

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  constructor(private http: HttpClient) {}

  //Global Templates

  getGlobalTemplateListByParams(companyId: number, createdBy: string, createdByName: string, sourceProject: string, sourceSection: string, query: string, sortField: string, sortDirection: string, page: number, pageSize: number): Observable<Page<GlobalTemplate>> {
    let params = new HttpParams();
    if (createdBy) params = params.set('createdBy', createdBy);
    if (createdByName) params = params.set('createdByName', createdByName);
    if (sourceProject) params = params.set('sourceProject', sourceProject);
    if (sourceSection !== null && sourceSection !== undefined) params = params.set('sourceSection', sourceSection);
    if (query && query.length > 0) params = params.set('query', query);
    if (sortField) params = params.set('sortField', sortField);
    if (sortDirection) params = params.set('sortDirection', sortDirection);
    if (page) params = params.set('page', page);
    if (pageSize) params = params.set('pageSize', pageSize);

    return this.http.get<Page<GlobalTemplate>>(`${apiUrl}/company/${companyId}/template/list`, {
      params: params,
      withCredentials: true
    })
  }

  getGlobalTemplateShortList(companyId: number, excludeSubRole?: SubRole): Observable<GlobalTemplate[]> {
    let params = new HttpParams().set('companyId', companyId);
    if (excludeSubRole) params = params.set('excludeSubRole', excludeSubRole);

    return this.http.get<GlobalTemplate[]>(`${apiUrl}/template/short`, {params: params, withCredentials: true})
  }

  getGlobalTemplateById(companyId: number, templateId: number): Observable<GlobalTemplate> {
    return this.http.get<GlobalTemplate>(`${apiUrl}/company/${companyId}/template/${templateId}`, {
      withCredentials: true
    })
  }


  getCreatedByList(companyId: number): Observable<string[]> {
    return this.http.get<string[]>(`${apiUrl}/company/${companyId}/template/list/createdBy`, {
      withCredentials: true
    })
  }

  getSourceProjectList(companyId: number): Observable<string[]> {
    return this.http.get<string[]>(`${apiUrl}/company/${companyId}/template/list/sourceProject`, {
      withCredentials: true
    })
  }

  getSourceSectionList(companyId: number): Observable<Array<string | TemplateSourceSectionFilterOption>> {
    return this.http.get<Array<string | TemplateSourceSectionFilterOption>>(`${apiUrl}/company/${companyId}/template/list/sourceSection`, {
      withCredentials: true
    })
  }

  createGlobalTemplate(id: number, template: GlobalTemplate): Observable<GlobalTemplate> {
    return this.http.post<GlobalTemplate>(`${apiUrl}/company/${id}/template`, template, {
      context: new HttpContext().set(SUPPRESS_DUPLICATE_NAME_NOTIFICATION, true),
      withCredentials: true
    })
  }

  updateGlobalTemplateById(companyId: number, template: GlobalTemplate): Observable<GlobalTemplate> {
    return this.http.put<GlobalTemplate>(`${apiUrl}/company/${companyId}/template`, template, {
      context: new HttpContext().set(SUPPRESS_DUPLICATE_NAME_NOTIFICATION, true),
      withCredentials: true
    })
  }

  deleteGlobalTemplates(companyId: number, templateIds: number[]) {
    let params = new HttpParams();
    templateIds.forEach(e => params = params.append('templateIds', e));

    return this.http.delete(`${apiUrl}/company/${companyId}/template`, {
      params: params,
      observe: "response",
      withCredentials: true
    })
  }


  //Project Rooms and Templates


  getRoomTemplatesShortList(sectionId: number) {
    return this.http.get<Room[]>(`${apiUrl}/section/${sectionId}/templates/short`, {withCredentials: true})
  }
  getAllRoomTemplatesList(sectionId: number) {
    return this.http.get<Room[]>(`${apiUrl}/section/${sectionId}/templates`, {withCredentials: true})
  }

  getTemplateById(sectionId: number, templateId: number) {
    return this.http.get<Room>(`${apiUrl}/section/${sectionId}/templates/${templateId}`, {withCredentials: true})
  }

  updateTemplate(sectionId: number, templateId: number, template: Room) {
    return this.http.put<Room>(`${apiUrl}/section/${sectionId}/templates/${templateId}`,template, {withCredentials: true})
  }

  deleteTemplateById(sectionId: number, templateId: number) {
    return this.http.delete(`${apiUrl}/section/${sectionId}/templates/${templateId}`, {withCredentials: true})
  }
}


